import { Link } from "react-router-dom";
import StarField from "@/components/StarField";
import TopBar from "@/components/TopBar";
import Footer from "@/components/Footer";
import { motion } from "framer-motion";

const EYE_URL =
  "https://customer-assets.emergentagent.com/job_18d0b8e0-400c-48e8-b04b-0dc215769997/artifacts/xqy28j4d_image.png";

const GATES = [
  { to: "/access-code", title: "Enter Access Code", sub: "Instagram drop", testid: "gate-access-code" },
  { to: "/register?intent=membership", title: "Become A Member", sub: "$10 / month — Inner Circle", testid: "gate-member" },
  { to: "/influencer/login", title: "Influencer Login", sub: "Restricted portal", testid: "gate-influencer" },
];

export default function Landing() {
  return (
    <div className="relative min-h-screen overflow-hidden">
      <StarField count={180} />
      <TopBar />

      <main className="relative z-20 flex flex-col items-center px-6 pt-6 pb-24">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.4, ease: "easeOut" }}
          className="eye-float mt-2"
          data-testid="landing-eye-logo"
        >
          <img src={EYE_URL} alt="Soulciety eye" className="w-44 sm:w-56 lg:w-72 select-none pointer-events-none" />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 1 }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-black text-center mt-10 tracking-tight neon-cyan"
          data-testid="landing-heading"
        >
          THE SECRET<br /><span className="text-white">SOULCIETY CLUB</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 1 }}
          className="font-mono text-sm sm:text-base uppercase tracking-[0.3em] text-white/60 text-center max-w-2xl mt-6"
          data-testid="landing-subtext"
        >
          Exclusive events · Private entry · Limited capacity<br />Invitation-based access only
        </motion.p>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.1, duration: 1 }}
          className="font-display italic text-cyan-400/80 text-xs sm:text-sm tracking-[0.4em] uppercase mt-12"
        >
          you do not browse events. you are granted access.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mt-14 w-full max-w-5xl">
          {GATES.map((g, i) => (
            <motion.div
              key={g.to}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.2 + i * 0.15, duration: 0.6 }}
            >
              <Link
                to={g.to}
                data-testid={g.testid}
                className="gate group relative block rounded-sm p-8 text-center transition-all hover:-translate-y-1"
              >
                <div className="absolute inset-0 rounded-sm bg-gradient-to-br from-cyan-500/0 via-white/0 to-fuchsia-500/0 group-hover:from-cyan-500/10 group-hover:to-fuchsia-500/10 transition-all" />
                <div className="relative">
                  <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-cyan-400/80 mb-4">— gate {String(i + 1).padStart(2, "0")} —</div>
                  <div className="font-display font-bold text-xl sm:text-2xl uppercase tracking-wider text-white group-hover:neon-cyan transition">{g.title}</div>
                  <div className="font-mono text-xs uppercase tracking-widest text-white/50 mt-3">{g.sub}</div>
                  <div className="mt-6 inline-block font-mono text-[10px] tracking-[0.3em] uppercase text-white/40 group-hover:text-cyan-300 transition">
                    Approach →
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

        <div className="mt-20 text-center max-w-2xl text-white/40 font-mono text-xs uppercase tracking-[0.3em]">
          <p>Capacity is finite. Identity is verified. Discretion is the currency.</p>
        </div>
      </main>

      <Footer />
    </div>
  );
}
